export const couponMessages = {
    DOESNT_QUALIFY_FOR: "Doesn't qualify for ",
    SPEND_MORE_TO_QUALIFY: 'subtotal must reach a higher amount',
};
export const shippingMessages = {
    PICKUP_TODAY: 'Pickup Today',
    PICKUP_MESSAGE: 'Orders placed after 3 p.m will be available the next day.',
    STORE_ADDRESS_TYPE: 'STORE_ADDRESS',
    HOME_ADDRESS_TYPE: 'HOME_ADDRESS',
};
export const shippingAddressFormLabels = {
    FIRST_NAME_LABEL: 'First Name',
    LAST_NAME_LABEL: 'Last Name',
    COMPANY_NAME_LABEL: 'Company Name',
    EMAIL_LABEL: 'Email',
    MILITARY_ADDRESS_TYPES_LABEL: 'APO/FPO/DPO',
    ADDRESS_LINE_ONE_LABEL: 'Street Address',
    ADDRESS_LINE_TWO_LABEL: 'Apt, Suite, Floor',
    ADDRESS_LINE_THREE_LABEL: 'Street Address 3',
    ADDRESS_LINE_TWO_LABEL_ALT: 'Street Address 2',
    ADDRESS_LINE_TWO_BUTTON_LABEL: 'Add Street Address 2 (Optional)',
    ADDRESS_LINE_THREE_BUTTON_LABEL: 'Add Street Address 3 (Optional)',
    ADDRESS_LINE_ONE_PLACEHOLDER: 'Enter your address',
    ZIPCODE_LABEL: 'Zip Code',
    ZIPCODE_LABEL_ALT: 'Postal Code',
    PHONE_LABEL: 'Phone Number',
    COUNTRY_LABEL: 'Country',
    ALTERNATE_PHONE_LABEL: 'Alternate Phone Number',
    CITY_LABEL: 'City',
    STATE_LABEL: 'State',
    STATE_LABEL_ALT: 'Province/Territory/Region',
    DELIVERY_INSTRUCTIONS: 'Special Delivery Instructions',
    INSTRUCTIONS_PLACEHOLDER: 'Ex: The building gate code is 5555',
    DEFAULT_TAG: 'DEFAULT',
    CONTINUE: 'CONTINUE',
    CONTINUE_TO_PAYMENT: 'Continue to Payment',
    CONTINUE_TO_REVIEW: 'Continue to Review',
    FORM_LABEL_NEW: 'Ship to',
    FORM_LABEL_EDITING: 'Edit Address',
    VIEW_MORE_LABEL: 'View More',
};
export const shippingAddressFormMessages = {
    LARGE_APPLIANCE_MESSAGE:
        'Parts, services, and installation are specific to your delivery zip code. Please select or add an address in zip ',
};
export const productAttributes = {
    SIZE: 'SIZE',
    SIZE_RANGE: 'SIZE RANGE',
    COMBINED_SIZE: 'COMBINED_SIZE',
    COLOR: 'COLOR',
};
export const truckableProductConstants = {
    truckDeliveryLabel: 'Truck Delivery ',
    truckDeliveryFeeLabel: 'Delivery fee may apply ',
    estDeliveryText: 'Est. Delivery:',
};
export const protectionPlanTypes = ['SERVICE', 'REGULAR'];
export const paymentMethodIconMap = {
    AMEX: 'american-express.svg',
    AMERICANEXPRESS: 'american-express.svg',
    DISCOVER: 'discover.svg',
    GIFTCARD: 'giftcard.svg',
    JCPMASTER: 'jcpmastercard.svg',
    JCPENNEYMASTERCARD: 'jcpmastercard.svg',
    JCP: 'jcp-plcc.svg',
    MASTER: 'mastercard.svg',
    MASTERCARD: 'mastercard.svg',
    PAYPAL: 'paypal.svg',
    VISA: 'visa.svg',
    APPLEPAY: 'applepay.svg',
};
export const creditCardGroupMessage = {
    acceptableGroupText:
        'JCPenney Card, JCPenney Mastercard, Visa, Mastercard, Discover, American Express',
};
export const createAccountTitle = {
    SUCCESS: 'Account created!',
    ERROR: 'Oops! Something went wrong.',
    INFORMATION: 'Express Checkout failed',
};
export const createAccountMessageCategory = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFORMATION: 'information',
};
export const createAccountErrorMessages = {
    EMPTY_INPUT_ERROR: 'Please enter valid password',
    NON_ALLOWED_SPECIALS_ERROR: 'Not all special characters are allowed',
    MISC_CHARS_ERROR:
        'Password cannot have name, email, spaces, jcp or jcpenney, 3+ consecutive characters',
    MINIMUM_REQ_NOT_MET_ERROR: 'Password does not meet requirements',
};
export const LEARN_MORE = 'Learn More';
export const shippingGroupTitle = {
    HOME: 'Ship to Home',
    BOPIS: 'Same Day Pickup',
    STORE: 'Ship to Store',
    SHIPPING: 'Shipping',
};
export const checkoutAccordionTitle = {
    SDPU: 'Same Day Pickup',
    SHIPPING: 'Shipping',
    PAYMENT: 'Payment',
    REVIEW: 'Review',
};
export const shippingGroupType = {
    HOME: 'HOME',
    BOPIS: 'BOPIS',
    STORE: 'STORE',
};
export const shippingDeliveryType = {
    STANDARD: 'Standard',
    GROUND3DAY: 'Premium',
    EXPRESS_ECONOMY: 'Express',
    EXPRESS: 'Expedited',
    TRUCK: 'Truck',
    WILLCALL: 'Will Call',
};
export const shippingGroupTitleImgPath = {
    standard: 'svg/icon-truck.svg',
    pickup: 'svg/sameday-pickup.svg',
    store: 'svg/icon-store.svg',
};
export const fulfillmentShippingMethodMap = {
    1: 'standard',
    2: 'pickup',
    3: 'store',
};
export const adjustmentType = {
    COUPON: 'COUPON',
    ENTERPRISE: 'ENTERPRISE',
    REWARD: 'REWARDSCERT',
    FREESHIP: 'CouponSHFree',
    ASSOC_DISCOUNT: 'ASSOCIATEDISCOUNT',
    SHIPPING: 'SHIPPING',
    NEW_CUSTOMER: 'NEWCUSTOMER',
    RESTRICTED: 'RESTRICTED',
};

export const chargeType = {
    SHIPPINGANDHANDLING: 'SHIPPING AND HANDLING',
    RETAILDELIVERYFEE: 'RETAIL DELIVERY FEE',
    TAX: 'TAX',
    ROUNDUP: 'ROUND UP',
    SHIPTOSTORE: 'SHIP TO STORE',
    SHIPTOHOME: 'SHIP TO HOME',
};
export const productType = {
    REGULAR: 'REGULAR',
    LARGE_APP: 'LARGEAPPLIANCE',
};
export const HAULAWAY_TYPE = 'HAULAWAY TYPE';
export const feeTypes = {
    RECYCLE: 'Recycle',
    DISPOSABLE: 'Disposal',
};
export const ASSOC_DISCOUNT_LABEL = 'Assoc. Discount';
export const PICK_UP_METHOD = 'pickup';
export const PICK_UP_OPTION_ID = 2;
export const PICKUP_PERSON = 'Pickup Person';
export const ALTERNATE_PHONE_TITLE = 'Alternate Phone';
export const SPL_DELIVERY_INST_TITLE = 'Special Delivery Instructions';
export const ABOUT_DELIVERY_TITLE = 'About Delivery';
export const ABOUT_DELIVERY_DESC =
    'Our delivery agent will call 24 hours prior to the selected date to provide the delivery window. After delivery, you may be contacted about your satisfaction. All contacts may be automated calls to the number you provided for delivery. ';
export const transactionalSMSData = {
    id: 'transaction',
    textOrderStatus: ' (text order status)',
};
export const specialFinancingOfferTitle = 'Selected special financing Offer:';
export const specialFinancingOfferInformation =
    'This offer will be applied to the portion of your order total that is charged to your JCPenney credit card.';
export const plccBannerSynchronyURL =
    'https://www.onlinecreditcenter6.com/eapplygen2/load.do?cHash=1342177401&subActionId=1000&langId=en&siteCode=JWBCART717&cmpid=JWBCART717';
export const googlePlayBadgeURL = 'https://play.google.com/store/apps/details?id=com.jcp&amp;hl=en';
export const appStoreBadgeURL = 'https://itunes.apple.com/us/app/jcpenney/id925338276?mt=8';
export const orderTotalsName = {
    ORDERAMOUNT: 'Order amount',
    ADJUSTMENT: 'Adjustment',
    BALANCE: 'Balance',
    SAVINGS: 'Savings',
    SUBTOTAL: 'Sub total',
};
export const productCartridgeAttributes = {
    EMPTYCART: {
        pagetype: 'EMPTYCART',
        slotTypeOne: 'emptycart1',
        slotTypeTwo: 'emptycart2',
        slotIdOne: 'emptycart1_rr',
        slotIdTwo: 'emptycart2_rr',
        automationIdOne: 'emptycart-product-cartridge-one',
        automationIdTwo: 'emptycart-product-cartridge-two',
    },
    CART: {
        pagetype: 'CART',
        slotTypeOne: 'cart1',
        slotTypeTwo: 'cart2',
        slotIdOne: 'cart1_rr',
        slotIdTwo: 'cart2_rr',
        automationIdOne: 'cart-product-cartridge-one',
        automationIdTwo: 'cart-product-cartridge-two',
    },
};
export const certonaRecommendationsEmptyCart = true;
export const certonaRecommendationsCart = true;
export const certonaRecommendationsAddToCart = true;
export const itemsTotalsName = {
    TOTALWITHOUTDISCOUNT: 'TOTALWITHOUTDISCOUNT',
    SAVINGS: 'SAVINGS',
    ITEMAMOUNT: 'ITEM AMOUNT',
};
export const itemSurchargeTypes = {
    'OVERSIZE SURCHARGE': {
        code: 'OVERSIZE SURCHARGE',
        description: 'Oversized item surcharge',
        TooltipMsg:
            'An oversized item surcharge may apply to some heavy or bulky items due to size, weight or special handling required. This item surcharge is in addition to standard shipping rates.',
    },
    'MONOGRAM SURCHARGE': {
        code: 'MONOGRAM SURCHARGE',
        description: 'Monogram item surcharge',
    },
    ITEM_SURCHARGE_TYPES: {
        'OVERSIZE SURCHARGE': {
            code: 'OVERSIZE SURCHARGE',
            description: 'Oversized item surcharge',
        },
        'MONOGRAM SURCHARGE': {
            code: 'MONOGRAM SURCHARGE',
            description: 'Monogram item surcharge',
        },
    },
};
export const ORDER_QUANTITY_CHANGE_WARNING = 'Available quantity has changed please review';
export const emptyCart = {
    CART_IS_EMPTY: 'Your Cart is Empty',
    VIEW_COUPONS: "View Today's Coupons",
    START_SHPNG: 'Start Shopping',
    SHOP_NOW: 'Shop now, check out our ',
    COUPONS: 'Coupons',
};
export const changeStore = {
    orderMessage: 'Same day pickup items ordered after 3 PM will be available the next day',
};
export const singleClickCheckout = {
    NEED_TO_MAKE_CHANGE: 'View/Edit Order Details',
    INCLUDES_TAX: 'Includes tax',
    SUBTOTAL: 'Subtotal:',
    SUBTOTAL_AFTER_DISCOUNT: 'Subtotal after discounts:',
    TOTAL: 'Total',
    YOU_SAVED: 'You Saved:',
    ORDER_SUMMARY_CHEVRON: 'orderSummaryChevron',
};
export const LARGE_APPLIANCE_INSTALL_TYPE = 'LARGEAPPLIANCEINSTALL';
export const CURRENCY_US = 'USD';
export const MAXALLOWEDGIFTCARD = 2;
export const CLEARANCECOUPON = 'CLEARANCE';
export const DEVICE_ACCNO = 'Device Account Number';
export const PROTECTION_TITLE_NAME = 'Protection';
export const PARTS_AND_SERVICE_TITLE_NAME = 'Parts & Services';
export const DIGITAL_DELIVERY_METHOD = 'Email';
export const APPLIANCEINSTALLATION_LABEL = 'Appliance Installation';
export const LARGEAPPLIANCEINSTALL_TYPE = 'LARGEAPPLIANCEINSTALL';
export const childItemGroups = ['Care Plans', 'More Options'];
export const childItemGroupTitleMap = {
    'Care Plans': 'Protection',
    'More Options': 'Parts & Services',
};
export const childItemsType = {
    CARE_PLAN: 'care plan',
    SERVICES_AND_PARTS: 'Services & parts',
};
export const ANALYTICS = {
    AVAILABLE: 'available',
    AVAILABLE_CAPS: 'AVAILABLE',
    PACKAGE_DEAL: 'package deal',
    PAGE_NAME: {
        CART_GIFTCARD_LANDING: 'gift card balance landing',
        CART_GIFTCARD_SUCCESS: 'gift card balance success',
        CHECKOUT_SHOPPING_CART: 'checkout shopping cart',
        CHECKOUT_LOGIN: 'checkout login',
        CHECKOUT_SAME_DAY_PICKUP: 'checkout same day pickup',
        CHECKOUT_SHIPPING: 'checkout shipping',
        CHECKOUT_PAYMENT: 'checkout payment',
        CHECKOUT_REVIEW: 'checkout review',
        CHECKOUT_ORDER_CONFIRMATION: 'checkout order confirmation',
        SINGLE_CLICK_CHECKOUT: 'single click checkout',
    },
    PAGE_TYPE: {
        SHOPPING_CART: 'shopping cart',
        CHECKOUT: 'checkout',
        ACCOUNT: 'account',
    },
    VERSION: {
        EMPTY_CART: 'apollo 1 empty cart',
        CART: 'apollo 1 cart',
        SINGLE_CLICK_CHECKOUT: 'apollo 1 scc',
        GC_BALANCE: 'apollo 1 gc balance',
        CHECKOUT_SIGN: 'apollo 1 checkout sign in',
        SDPU: 'apollo 1 sdpu',
        SHIPPING: 'apollo 1 shipping',
        PAYMENT: 'apollo 1 payment',
        REVIEW: 'apollo 1 review',
        OCP: 'apollo 1 ocp',
    },
    BEST_COUPON: '-best',
    BOF: '-bof',
    TOTALWITHOUTDISCOUNT: 'TOTALWITHOUTDISCOUNT',
    ORIGINAL: {
        KEY: 'ORIGINAL',
        VALUE: 'regular',
    },
    CLEARANCE: {
        KEY: 'CLEARANCE',
        VALUE: 'clearance',
    },
    SALE: {
        KEY: 'SALE',
        VALUE: 'sale',
    },
    NFORPRICE: {
        KEY: 'NFORPRICE',
        VALUE: 'buy more and save',
    },
    SHIPTOHOME: {
        KEY: 'HOME',
        VALUE: 'ship to home',
    },
    STORE: {
        KEY: 'STORE',
        VALUE: 'ship to store',
    },
    BOPIS: {
        KEY: 'BOPIS',
        VALUE: 'same day pickup',
    },
    BOPIS_ONLY: {
        KEY: 'BOPIS ONLY',
        VALUE: 'same day pickup only',
    },
    SHIPTOHOMEORSTORE: {
        KEY: 'SHIPTOHOMEORSTORE',
        VALUE: 'ship to home or store',
    },
    PRODUCTAVAILABILITY: {
        ONLINEONLY: 'online only',
        BOTH: 'both',
        STOREONLY: 'store only',
    },
    LOCAL_STORAGE_KEY: {
        CART_TOTAL: 'YODA_CART_TOTAL',
    },
    ORDERUID: 'orderUid',
    CAREPLAN: 'care plan',
    BUYMOREANDSAVE: 'buy more and save',
    RECYCLE: 'Recycle',
    OVERSIZESURCHARGE: 'OVERSIZE SURCHARGE',
    REWARDSCERTIFICATE: 'REWARDSCERTIFICATE',
    REWARDSCERT: 'REWARDSCERT',
    ASSOCIATEDISCOUNT: 'ASSOCIATEDISCOUNT',
    ORDERAMOUNT: 'ORDER AMOUNT',
    SUBTOTALAFTERADJUSTMENT: 'SUB TOTAL AFTER ADJUSTMENT',
    NFORDISCOUNT: 'NFORDISCOUNT',
    BXGXDISCOUNT: 'BXGXDISCOUNT',
    SUBTOTAL: 'SUB TOTAL',
    SHIPPINGANDHANDLING: 'SHIPPING AND HANDLING',
    COUPON: 'COUPON',
    REWARD_CODE: 'REWARDSCERT',
    PRICING_SERVICE: 'PricingService',
    YES: 'yes',
    NO: 'no',
    FAIL: 'failed',
    ZERO: '0.00',
    EMPTY: '',
    AH: 'AH',
    NO_MARKETING_LABEL: 'no marketing label',
    EXPRESS_CHECKOUT_ELIGIBLE: 'expressCheckoutEligible',
    EXPEDITED_CHECKOUT_ELIGIBLE: 'expediteCheckoutEligible',
    COUPONDISCOUNT: 'couponDiscount',
    CAREPLAN_DELIVERY_METHOD: {
        MAIL: 'mail',
        EMAIL: 'email',
    },
    PAYMENT: {
        VISA: 'visa',
        JCPGIFTCARD: 'giftcard',
        PAYPAL: 'paypal',
        CC: 'creditcard',
        JCP: 'jcp',
        APPLEPAY: 'apple pay',
        MASTERCARD: 'mastercard',
        DISCOVER: 'discover',
        AMEX: 'american express',
        VERIFIED: 'verified',
        MASTER: 'master',
        JCPMASTER: 'jcpmaster',
        JCPMASTER_VAL: 'jcpenney mastercard',
        AMEX_KEY: 'amex',
        KLARNA: 'Klarna',
    },
    APPLY_REWARDS: 'Apply rewards',
    GUEST: 'guest',
    LOGGEDIN: 'logged-in',
    TAX: 'TAX',
    GIFTWRAP: 'GIFTWRAP',
    ROUNDUP: 'ROUND UP',
    FREE: 'FREE',
    INSTOCK: {
        KEY: 'instock',
        VALUE: 'in stock',
    },
    AVAILABLELOW: {
        KEY: 'availablelow',
        VALUE: 'limited stock available',
    },
    LIMITEDSTOCKAVAILABLE: {
        KEY: 'limitedstockavailable',
        VALUE: 'limited stock available',
    },
    LIMITEDQUANTITIES: {
        KEY: 'limitedquantities',
        VALUE: 'limited stock available',
    },
    OUTOFSTOCK: {
        KEY: 'outofstock',
        VALUE: 'out of stock',
    },
    NOTAVAILABLE: {
        KEY: 'notavailable',
        VALUE: 'out of stock',
    },
    BACKORDERED: {
        KEY: 'backordered',
        VALUE: 'backordered',
    },
    DISCONTINUED: {
        KEY: 'discontinued',
        VALUE: 'discontinued',
    },
    SHIPPINGMETHOD: {
        STANDARD: 'standard delivery',
        GROUND3DAY: 'premium delivery 3 business days',
        EXPRESS_ECONOMY: 'express delivery 2 business days',
        EXPRESS: 'expedited delivery 1 business day',
        TRUCK: 'truck delivery',
        BOPIS: 'same day pickup',
    },
    SHIPPINGTYPE: {
        GROUND3DAY: 'GROUND3DAY',
        EXPRESS_ECONOMY: 'EXPRESS_ECONOMY',
        EXPRESS: 'EXPRESS',
    },
    PAGE_INFO: {
        CART: 'cart',
        CHECKOUT: 'checkout',
        PAGE_TYPE: {
            CART: 'rewardsorcouponsoncart',
            CHECKOUT: 'rewardsorcouponsoncheckout',
        },
    },
    ACTIONS: {
        CREATE_ACCOUNT: 'CREATE_ACCOUNT',
        LINK_REWARDS_ACCOUNT: 'LINK_REWARDS_ACCOUNT',
        UPDATE_CART: 'UPDATE_CART',
        SAVE_FOR_LATER: 'SAVE_FOR_LATER',
        REMOVE_ITEM: 'REMOVE_ITEM',
        MOVE_TO_CART: 'MOVE_TO_CART',
        SAME_DAY_PICKUP: 'SAME_DAY_PICKUP',
        PAYPAL_CHECKOUT: 'PAYPAL_CHECKOUT',
        COUPON_APPLIED_SUCCESS: 'COUPON_APPLIED_SUCCESS',
        SELECT_STORE_SUCCESS: 'SELECT_STORE_SUCCESS',
        FIND_COUPON: 'FIND_COUPON',
        EXPRESS_CHECKOUT: 'EXPRESS_CHECKOUT',
        EXPEDITED_CHECKOUT: 'EXPEDITED_CHECKOUT',
        INTERSTITIAL_UPDATE_CART: 'INTERSTITIAL_UPDATE_CART',
        PRODUCT_CO_OOS: 'PRODUCT_CO_OOS',
        LOGIN_ATTEMPTED: 'LOGIN_ATTEMPTED',
        LOGIN_SUCCESS: 'LOGIN_SUCCESS',
        LOGIN_FAILED: 'LOGIN_FAILED',
        EDIT_CARD_AT_CHECKOUT: 'EDIT_CARD_AT_CHECKOUT',
        DELETE_CARD_AT_CHECKOUT: 'DELETE_CARD_AT_CHECKOUT',
        VIEW_FINANCE_OFFER_MODAL: 'VIEW_FINANCE_OFFER_MODAL',
        ACCEPT_FINANCE_OFFER_MODAL: 'ACCEPT_FINANCE_OFFER_MODAL',
        PLCC_DYN_BANNER_GET_DETAIL: 'PLCC_DYN_BANNER_GET_DETAIL',
        CAPTCHA_ERROR: 'CAPTCHA_ERROR',
        APPLE_PAY_CHECKOUT: 'APPLE_PAY_CHECKOUT',
        CART_ADD: 'CART_ADD',
        CROSSSELL_CART_ADD: 'CROSSSELL_CART_ADD',
        PAYPAL_STEP_CHECKOUT: 'PAYPAL_STEP_CHECKOUT',
        COUPON_REMOVED: 'COUPON_REMOVED',
        OPTIONAL_SERVICE: 'OPTIONAL_SERVICE',
        ADDITIONAL_PROTECTION_PLAN: 'ADDITIONAL_PROTECTION_PLAN',
        OPTIONAL_SERVICE_UPDATE_CART: 'OPTIONAL_SERVICE_UPDATE_CART',
        OPTIONAL_SERVICE_ADD_CART: 'OPTIONAL_SERVICE_ADD_CART',
        OPTIONAL_SERVICE_REMOVE_CART: 'OPTIONAL_SERVICE_REMOVE_CART',
        APP_WALLET_GIFT_CARD_APPLY: 'APP_WALLET_GIFT_CARD_APPLY',
        PLCC_APPLY_NOW_LINK: 'PLCC_APPLY_NOW_LINK',
        PLCC_GET_DETAILS: 'PLCC_GET_DETAILS',
    },
    EVENTS: {
        CREATE_ACCOUNT: 'accountRegistration',
        LINK_REWARDS_ACCOUNT: 'linkRewardsAccount',
        UPDATE_CART: 'cartUpdate',
        SAVE_FOR_LATER: 'saveProductInCart',
        REMOVE_ITEM: 'cartUpdate',
        MOVE_TO_CART: 'moveSavedProductToCart',
        SAME_DAY_PICKUP: 'sameDayPickup',
        PAYPAL_CHECKOUT: 'paypalCheckout',
        COUPON_APPLIED_SUCCESS: 'couponApplied',
        SELECT_STORE_SUCCESS: 'selectStore',
        FIND_COUPON: 'findCoupon',
        EXPRESS_CHECKOUT: 'expressCheckout',
        EXPEDITED_CHECKOUT: 'expeditedCheckout',
        INTERSTITIAL_UPDATE_CART: 'cartUpdate',
        PRODUCT_CO_OOS: 'productCheckoutOOS',
        LOGIN_ATTEMPTED: 'loginAttempted',
        LOGIN_SUCCESS: 'loginSuccess',
        LOGIN_FAILED: 'loginFailed',
        EDIT_CARD_AT_CHECKOUT: 'modifyCreditCardAtCheckout',
        DELETE_CARD_AT_CHECKOUT: 'modifyCreditCardAtCheckout',
        VIEW_FINANCE_OFFER_MODAL: 'financeOfferView',
        ACCEPT_FINANCE_OFFER_MODAL: 'financeOfferAccept',
        PLCC_DYN_BANNER_GET_DETAIL: 'getDetailPlccSlideOver',
        CAPTCHA_ERROR: 'captchaImpression',
        APPLE_PAY_CHECKOUT: 'applePayCheckout',
        GIFT_CARD_BANNER: 'giftCardBanner',
        CART_ADD: 'cartAdd',
        CROSSSELL_CART_ADD: 'cartAdd',
        PAYPAL_STEP_CHECKOUT: 'paypalStepCheckout',
        COUPON_REMOVED: 'couponRemoved',
        OPTIONAL_SERVICE: 'optionalServicesCart',
        ADDITIONAL_PROTECTION_PLAN: 'additionalProtectionCart',
        OPTIONAL_SERVICE_UPDATE_CART: 'cartUpdate',
        OPTIONAL_SERVICE_REMOVE_CART: 'cartUpdate',
        OPTIONAL_SERVICE_ADD_CART: 'cartAdd',
        APP_WALLET_GIFT_CARD_APPLY: 'applygiftcardfromwallet',
        PLCC_APPLY_NOW_LINK: 'plccapplynowlink',
        PLCC_GET_DETAILS: 'plccgetdetails',
    },
    CHECKOUT_BTN_POSN: {
        NON_STICKY: 'primary-main',
        STICKY: 'secondary-sticky',
    },
    VIEWPORT: {
        SMALL: 'small',
        MEDIUM: 'medium',
        LARGE: 'large',
        XLARGE: 'x-large',
    },
    CO_PROCESS_TYPE: {
        GUEST: 'guest',
        REGISTERED: 'standard',
        EXPEDITED: 'expedited',
        EXPRESS: 'express',
        PAYPAL: 'paypal',
        APPLE_PAY: 'apple pay',
        SINGLE_CLICK: 'single click',
        PAYPAL_EXPRESS: 'paypal express',
    },
};
export const pickupWarning = {
    title: 'About Same Day Pickup',
    subTitle: 'Changing your Same day Pickup Store may affect all item eligibility.',
};
export const paymentMethod = {
    CREDITCARD: 'creditCard',
    GIFTCARD: 'giftCard',
    PAYPAL: 'paypal',
};
export const baseOfferLabel = {
    clearance: 'CLEARANCE',
    original: 'ORIGINAL',
    sale: 'SALE',
    default: 'DEFAULT',
    packageDeal: 'Package Deal',
    nForPrice: 'NFORPRICE',
    bxgxPrice: 'ITEM_PRICE',
    bopisincentive: 'BOPISINCENTIVE',
};
export const basePromotionCode = {
    nfor: 'NFor',
    bxgx: 'BxGx',
};
export const basePriceLabel = {
    nfor: 'NFORDISCOUNT',
    bopisincentive: 'BOPISINCENTIVE',
};
export const estDeliveryLabel = 'Est. Delivery:';
export const getItOn = 'Get it on';
export const getItBy = 'Get it by';
export const getIt = 'Get it';
export const PRODUCT_URL = '/p//?ppId=';
export const PRODUCT_URL_DESKTOP = '/p/product.jsp?ppId=';
export const couponsSubType = {
    promotional: 'PROMOTIONAL',
    shipping: 'SHIPPING',
};
export const InventoryStatus = {
    INSTOCK: {
        status: 'INSTOCK',
        displayDesc: '',
    },
    OUTOFSTOCK: {
        status: 'OUTOFSTOCK',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    NOTAVAILABLE: {
        status: 'OUTOFSTOCK',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    LIMITEDSTOCKAVAILABLE: {
        status: 'LIMITEDSTOCKAVAILABLE',
        desc: 'Low Stock',
        styleClass: 'lowStock',
    },
    BACKORDERED: {
        status: 'BACKORDERED',
        desc: '',
    },
    OUTOFSTOCKONLINE: {
        status: 'OUT OF STOCK ONLINE',
        desc: 'Out of Stock',
        styleClass: 'outOfStock',
    },
    LIMITEDQUANTITY: {
        status: 'LIMITED QUANTITY',
        desc: 'Low Stock',
        styleClass: 'lowStock',
    },
    DISCONTINUED: {
        status: 'DISCONTINUED',
        desc: 'Discontinued',
        styleClass: 'outOfStock',
    },
};

export const ValidInventoryStatusList = ['limited quantity', 'out of stock online'];

export const giftRegistry = {
    source: 'GIFTREGISTRY',
    message: 'address hidden for security',
    label: 'Gift Registry Address',
};
export const pdpUrlConfig = {
    DESKTOP_PDP_SUBCONTEXT: '/product.jsp?ppId=',
    PDP_SUBCONTEXT: '/product?ppId=',
    URL_PARAMETERS_INDEX: 1,
    PDP_APPLIANCE_UPSELL: '/upsell/configurator?ppId=',
};
export const URL = {
    CART_PAGE: '/cart',
    SIGN_IN_PAGE: '/cart/signin',
    RESET_PASSWORD_PAGE: '/cart/resetpassword',
    CHECKOUT_PAGE: '/checkout',
    REVIEW_PAGE: '/checkout/review',
    CONFIRMATION_PAGE: '/checkout/oc',
    PAYMENT_PAGE: 'Payment',
    SHIPPING_PAGE: 'Shipping',
    ACCOUNT_LOCKED: '/checkout/account-locked',
    HOME_PAGE: '/',
    CHECKOUT_SHIPPING: '/checkout/shipping',
    CHECKOUT_PAYMENT: '/checkout/payment',
    CHECKOUT_BOPIS: '/checkout/bopis',
};
export const JCP_HOSTNAME_MOBILE = 'm.jcpenney.com';
export const JCP_HOSTNAME_DESKTOP = 'www.jcpenney.com';
export const PAYPAL_URL_TEST = 'https://www.sandbox.paypal.com/checkoutnow?token=';
export const PAYPAL_URL_PROD = 'https://www.paypal.com/checkoutnow?token=';
export const PAYPAL_FORCE_WEB = '&&force_web=true';
export const PAYPAL_STRATEGY_TYPE = {
    NORMAL: 'paypal-normal',
    EXPRESS: 'paypal-express',
    PAYPAL: 'paypal',
};
export const PAY_PAYPAL =
    "Pay with PayPal. You'll return back to JCPenney to review your order before purchase.";
export const XCOMMAND = {
    CHECKOUT: 'initiate-checkout',
    PAYPAL_CHECKOUT: 'initiate-paypal-checkout',
};
export const ACCESS_TOKEN = 'ACCESSTOKEN';
export const REFRESH_TOKEN = 'REFRESHTOKEN';
export const ACCOUNT_ID = 'ACCOUNT_ID';
export const DP_REWARDS_STATUS = 'DP_REWARDS_STATUS';
export const NOT_ENROLLED = 'NotEnrolled';
export const ENROLLED = 'Enrolled';
export const OC_ACCOUNT_CREATION_NOTE =
    "We've saved your information, sign up by simply entering a phone number & password for";
export const googleMapAPIConfig = {
    API_URL: '//maps.googleapis.com/maps/api/js?key=',
    API_KEY: 'AIzaSyDc0dnG9cxE3N1wqkqY8_iumInyqrAR1bU',
    API_LIBRARY_PARAM_NAME: 'libraries',
    API_PLACE_LIBRARY: 'places',
    AUTO_COMPLETE_ID: 'autocomplete',
    AUTO_COMPLETE_ADDRESS_TYPE_POST_CODE: 'postal_code',
    AUTO_COMPLETE_ADDRESS_TYPE_STATE: 'administrative_area_level_1',
    AUTO_COMPLETE_ADDRESS_TYPE_CITY: 'locality',
    AUTO_COMPLETE_ADDRESS_FIELDS: ['name', 'address_components'],
};
export const offeringConstants = {
    MAIN_TITLE: 'Select Parts & Services',
    INSTALL_TITLE: 'Required installation parts',
    INSTALL_SUB_TITLE: 'Reuse of parts is prohibited',
    INSTALL_TITLE_MSG: 'Would you like us to install your appliance for',
    NO_INSTALL_MSG:
        'If basic installation is available for this item, it will be included for free.',
    SERVICE_TITLE: 'Additional Services',
    NO_SERVICE_MSG: 'No additional services are available.',
    CARE_PLAN_TITLE: 'Additional Protection',
    CARE_PLAN_SUB_TITLE: 'Protect your investment beyond the terms of your original warranty',
    INSTALLATION: 'Installation',
    DELIVERY_SERVICE_TITLE: 'Delivery Services',
    OPTIONAL_SERVICE_TITLE: 'Optional Services',
};
export const offeringTypes = {
    INSTALLATION: 'installation',
    OTHER: 'other',
    CARE_PLAN: 'care plan',
    ADDITIONAL_SERVICES: 'additionalServices',
};
export const creditCardFormConfig = {
    MONTH_LIST: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    ERROR_MSG: {
        unknownType:
            'We did not recognize the "type" of card you entered. Make sure you entered your "card number" correctly.',
        fieldRequired: ' ',
    },
    TOOLTIP_MSG:
        'This CVV is the last 3 digits on the back of your JCPenney MasterCard, Visa, MasterCard or Discover card. The security code on American Express cards is the 4 digit number on the front of your card above your account number.',
    TOOLTIP_JCP_CVV_MSG:
        'This CVV is the last 3 digits on the back of your JCPenney Credit Card. If you’re having difficulty finding it, call 1-800-527-4403 for assistance.',
    SITE_KEY: '6LdJACEUAAAAACsikWtpbBbF4NT7S-ItBaW__EGb',
};
export const PaymentAccordionSectionConfig = {
    ADD_GIFT_CARD_BUTTON_MSG: 'Add a Gift Card',
};
export const contentApiKeys = {
    RECYCLE_FEE: 'cf-recycle-fee',
    DISPOSABLE_FEE: 'cf-disposal-fee',
    RECYCLE_TRUCKABLE_FEE: 'cf-truckable-and-recycle-fee',
};
export const orderStatus = {
    SUBMITTED: 'SUBMITTED',
    DRAFT: 'DRAFT',
};
export const DeleteShippingAddressMsg = {
    HOME_ADDRESS: {
        DELETE_TITLE: 'Cannot Delete',
        DELETE_MSG:
            'This is set as your home address, Your home address cannot deleted. Please edit or add a new address.',
        CONFIRM_BTN_LABLE: 'Edit',
    },
    NO_HOME_ADDRESS: {
        DELETE_TITLE: 'Delete Address',
        DELETE_MSG: 'Are you sure you want to delete this address? This cannot be undone',
        CONFIRM_BTN_LABLE: 'Delete',
    },
};
export const shippingThreshold = {
    FREE_SHIPPING: 'FREE SHIPPING',
    FREE_SHIPPING_EARNED: 'FREE SHIPPING!',
    THRESHOLD_MET: "Great! You've earned",
    THRESHOLD_NOT_MET: 'more to earn',
    THRESHOLD_MET_NEW: 'Great! You earned',
    THRESHOLD_NOT_MET_NEW: 'Away From',
    THRESHOLD_NOT_MET_NEW_CART: 'Away from',
    FREE_SHIPPING_OVER: 'Shipping to home over',
    GET_FREE_SHIPPING: 'more to get',
    SHIPPING: 'Shipping',
    SHIPPING_EARNED: 'Shipping!',
    FREE: 'FREE',
};
export const patchFinancingParams = {
    OP: 'replace',
    PATH: '/selected',
};
export const shipToStoreLabels = {
    LABEL_CHANGE_STORE: 'Change Store',
    LABEL_ADD_NEW_STORE: 'Add New Store',
    SHIPPING_ADDRESS_TYPE: 'store',
    ENTER_CONTACT_INFORMATION: 'Enter contact information',
    CONTACT_MESSAGE: 'We’ll use this information to contact you about your order.',
    STANDARD_DELIVERY_MESSAGE: 'Standard delivery 4-7 business days',
    SHIPPING_METHOD: 'Shipping method',
};
export const silverItemInformation = {
    reviewMessage: 'A delivery agent will call to confirm your delivery window.',
    message:
        'You will be contacted within 7 to 14 days from the time the item is shipped to schedule a delivery appointment. After delivery you may be contacted about your satisfaction. All contacts may be automated calls to the number you provided for delivery.',
};
export const regularTruckInformation = {
    title: "We'll Contact You",
    message:
        'You will be contacted 7 to 14 days from the time the item is shipped to schedule a delivery appointment. After delivery, you may be contacted about your satisfaction. All contacts may be automated calls to the number you provided for delivery.',
};
export const deliveryInformation = 'Delivery Information';
export const silverZipCodeError = {
    lineOne: 'Please select or add an address in zipcode ',
    lineTwo: '. Parts and services are specific to your set delivery zip code.',
};
export const DOLLAROFF = 'ABSOLUTE';
export const PERCENTOFF = 'PERCENTAGE';
export const BONUSBUCK = 'JCP Bonus Bucks';
export const BONUSBUCK_CODES = ['bonus buck$'];
export const earnedRewards = {
    welcome: 'Welcome, ',
    jcpenney: 'JCPenney',
    rewardsMember: 'Rewards Member',
    rewardsLabel: 'In Rewards',
};
export const afoExpansion = {
    armyNavyMarinesLabel: 'Army/Navy/Marines: ',
    armyNavyMarinesValue: 'Enter Unit and box number',
    shipsLabel: 'Ships: ',
    shipsValue: 'Enter ship name and hull number',
    airforceLabel: 'Air Force: ',
    airforceValue: 'Enter PSC and box number',
};
export const enterAddress = 'Enter your address';
export const couponErrorMessages = {
    COUPON_CODE_MISSING: 'Please enter a coupon or reward code',
    INPUT_BOX_PLACEHOLDER: 'Enter promo code...',
    CODE_DOES_NOT_EXIST: 'Code does not exist',
    COUPON_REQUEST_ERROR:
        'Oops! Something must have happened. Please try to apply the coupon again',
    COUPON_CODE_EXPIRED:
        'Oh no! The code you typed in has already expired. Please apply an eligible coupon',
    SRV_COUPON_EXPIRED_ERR:
        'Oh no! The code you typed in has already expired. Please apply an eligible coupon',
    SERIAL_NUMBER_REQUIRED: 'Serial Number Required',
    SERIAL_NUMBER_REQ_MESSAGE:
        'This code requires a serial number. Please type in the serial number shown on your coupon or reward.',
    COUPON_NO_CART_ITEMS: 'We can apply this coupon code once you add an item to your bag',
    COUPON_DENIED: 'One or more items in your cart are not eligible for this code.',
};
export const COUPON_TYPEAHEAD_TRIGGER_LENGTH = 3;
export const IN_STORE_ONLY_COUPONS = 'INSTOREONLYCOUPONS';
export const CouponAppliedMethod = {
    INPUT_COUPON: 'manual',
    SELECT_COUPON: 'selected from list',
    SUMMARY_COUPON: 'from order summary',
};
export const CouponAppliedSection = {
    CART_PAGE: 'CART_PAGE',
    COUPON_SLIDER: 'COUPON_SLIDER',
    REWARD_SLIDER: 'REWARD_SLIDER',
    COUPON_SLIDER_LIST: 'COUPON_SLIDER_LIST',
    COUPON_ORDER_SUMMARY: 'COUPON_ORDER_SUMMARY',
    SERIAL_MODAL: 'SERIAL_MODAL',
};
export const GENERIC_ERROR_MSG =
    'Oops! there was an error processing your request. Please try again to proceed with your order.';
export const INVALID_GIFTCARD_ERROR_MSG =
    'The gift card you entered is invalid. Please use a different gift card or contact customer service at 800-294-8804.';
export const INVALID_GIFTCARD_CAPTCHA_MSG = 'Captcha is missing or incomplete';
export const SILVER_PHONE_TOOL_TIP_MSG =
    "We'll use this phone number to contact<br/>you about your order,including shipping<br/>status,delivery and post-delivery<br/>satisfaction. Contacts may be automated";
export const SILVER_ALTERNATE_TOOL_TIP_MSG =
    "We'll contact this person in case you're not <br/>available at the time of delivery.<br/>Contacts may be automated";
export const ENROLL_REWARDS_TOOL_TIP_MSG =
    "We'll use this number to look up, and track your Rewards when you shop in JCPenney stores.";
export const ZIPCODE_MISMATCH_SERVICE_ERROR_CODE =
    'Page_ADDRESS_SECTION__ADDRESS_KEY_LARGE_APP_ZIPCODE_MISMATCH_ERROR';
export const TOTAL_EXCEEDED_ERROR_MSG =
    'Your order exceeds $9,999.99, the maximum amount allowed on jcp.com. Please remove item(s) from your bag or move item(s) to your saved items list for later purchase.';
export const EXPOSED_PACKAGING_CHECKOUT_MSG =
    "Item may ship in original packaging, revealing what's inside. Make sure you're shipping to a safe location.";
export const EXPOSED_PACKAGING_CART_MSG = 'Item arrives in original packaging';
export const ACCOUNT_LOCKED_PAGE = {
    TITLE: 'You have been logged out...',
    MESSAGE:
        'In order to protect your account we have ended your session due to excessive payment attempts.',
    HOME_LINK: 'Return to Home',
};
export const CROSS_OOS_MESSAGE =
    'The following items have gone out of stock, and are no longer available.';
export const OUT_OF_STOCK = 'Out of Stock';
export const OOSOkLabel = 'Ok';
export const shippingFromFields = [
    'shippingAddressType',
    'firstName',
    'lastName',
    'lineOne',
    'militaryAddressType',
    'zip',
    'state',
    'city',
    'email',
    'phone',
];
export const paymentFromFields = [
    'creditCardNumber',
    'creditCardMonth',
    'creditCardYear',
    'creditCardCVV',
    'firstName',
    'lastName',
    'lineOne',
    'militaryAddressType',
    'zip',
    'state',
    'city',
    'email',
    'phone',
];
export const OOS_GENERIC_MESSAGE =
    'One or more items have become out of stock, and will be removed from your cart.';
export const OOS_MESSAGE =
    'One or more items have become out of stock, and will be removed if you checkout. You can edit the item to see if other product options are available. Same Day Pick Up items may be available at other stores.';
export const DISCONTINUED_MESSAGE =
    'One or more items are now discontinued and no longer available for purchase.';
export const SFL_OOS_MESSAGE =
    "You can edit this item to see if it's available in other options, or check back with us later to see if this item is back in stock.";
export const CAPTCHA_SITE_KEY = '6LcMZCcUAAAAANOx-VIvA8kcJxHn9I677Kzvtik0';
export const RECAPTCHA_SITE_KEY = '6Lf6BAYTAAAAAJ5F7IEbFCirG1uJCBmHS_34jtq7';
export const RECAPTCHA_ERRORCODES = {
    LAST_ATTEMPT: 'SVC_USR_ERR_PROFILE_ACCOUNT_LAST_ATTEMPT',
    NOT_FOUND: 'SRV_INVALID_CAPTCHA_REQUEST',
    INVALID: 'SRV_GC_CAPTCHA_INVALID',
    ERR_PROFILE_LOCKED: 'SVC_USR_ERR_PROFILE_LOCKED',
    PROFILE_LOCKED: 'SRV_PROFILE_LOCKED',
};
export const CAPTCHA_ENABLED = {
    SIGNIN: true,
    COUPON_REWARD: false,
    GIFTCARD: false,
    CREDITCARD: false,
};
export const DEVICE_FINGER_PRINT = {
    IOVATION_SRC: '//m.jcpenney.com/c/components/lib/DeviceFingerPrint/iovation.js',
    CONFIG_SRC: '//m.jcpenney.com/c/components/lib/DeviceFingerPrint/config.js',
};
export const THREAT_MATRIX_SRC = 'https://www.jcpenney.com/fp/check.js';
export const THREAT_MATRIX_SRC_NEW = 'https://dt-test4.jcpenney.com/fp/tags.js';
export const GENERIC_ERROR = {
    CART_MSG: 'Please refresh the page and try again.',
    CHECKOUT_MSG: 'Please refresh the page and try again or return to cart.',
    TITLE: "We've encountered a bit of a glitch.",
    REFRESH_BTN_LABLE: 'Refresh',
    CART_BTN_LABLE: 'Return to Cart',
    TOKEN_API_FAILED_MSG: 'Please try again.',
    OK_BTN_LABLE: 'OK',
};
export const BUNDLE_NAVIGATION = {
    NEXT: 'NEXT',
    PREVIOUS: 'PREVIOUS',
    CHECKOUT: 'CHECKOUT',
    BACK: 'BACK',
};
export const CHECKOUT_URL = '/cart';
export const CHECKOUT_DESKTOP_URL = '/cart';
export const CUSTOMER_SERVICE = 'by calling customer service.';
export const CANCEL_MESSAGE = 'You may cancel your order within';
export const CANCEL_ORDER_URL =
    '/orders/trackorders?CM_MMC=Trans-_-OrderConf-_-GBL-_-CheckOrderStatus&orderNumber=';
export const SERVICE_NUMBER = '1-800-322-1189';
export const ADD_INFO_TO_PROFILE_ERROR =
    'We are unable to save your information to profile at the moment. Please proceed with your order in the meantime and update details in my profile later.';
export const HOLIDAY_MESSAGE_CONTENT = 'cf-holiday-message-info';
export const PLCC_BANNER_CONTENT = 'cf-plcc-banner-cart-v1';
export const CURBSIDE_CART_CONTENT = 'cf-curbside-cart';
export const HOLIDAY_BOPIS_CONTENT = 'cf-holidaybopismsg-cart';
export const ROUNDUP_LEARNMORE_CONTENT = 'cf-rounduplearnmore';
export const EMPTY_CART_CONTENT = 'cf-empty-cart';
export const TRUCKABLE_RECYCLE_FEE_CONTENT = 'cf-truckable-and-recycle-fee';
export const REWARDS_BANNER_CONTENT = 'cf-rewards-banner-cart';
export const SHOP_REWARDS_BANNER_CONTENT = 'cf-shop-rewards-banner-cart';
export const CURBSIDE_OCP_CONTENT = 'cf-curbside-ocp';
export const TRUCKABLE_DELIVERY_CONTENT = 'cf-truckable-item-delivery-info';
export const LARGE_APP_TRUCK_DELIVERY_CONTENT = 'cf-large-app-truck-delivery-info';
export const HOLIDAY_BOPIS_MESSAGE_CONTENT = 'cf-holidaybopismsg';
export const CALIFORNIA_HA_MESSAGE_CONTENT = 'cf-californiahaulaway';
export const TOTAL_REDUCED = 'Great News! Your total has reduced to';
export const PAGE_TITLES = {
    CART: 'Cart - JCPenney',
    SIGN_IN: 'SignIn - JCPenney',
    CHECKOUT: 'Checkout - JCPenney',
    REVIEW_ORDER: 'Review Order - JCPenney',
    ORDER_CONFIRMATION: 'Order Confirmation - JCPenney',
    GIFT_CARD: 'Gift Card - JCPenney',
};
export const GOOGLE_ADS = {
    CART_PAGE_BOTTOM_LEFT: 'div-gpt-ad-691978983164912457-1',
    OC_PAGE_BOTTOM_LEFT: 'div-gpt-ad-jcpenney_orderconfirm-2',
    OC_PAGE_RIGHT_CENTER: 'div-gpt-ad-jcpenney_orderconfirm-1',
    GIFTCARD_PAGE_BOTTOM: 'div-gpt-ad-jcpenney_gift_card-1',
};
export const PLCC_DYN_BANNER = {
    BANNER_TEXT_PART1: 'Save up to',
    BANNER_TEXT_SMALL_PART1: 'Save an estimated',
    BANNER_TEXT_PART2: 'when you open and use a new JCPenney Credit Card',
    BANNER_TEXT_SPECIAL_FINANCING: ' and get special financing',
    BANNER_TEXT_SPECIAL_FINANCING_REGISTER: 'Get special financing on your purchase',
    BANNER_TEXT_REGISTER_CONTENT_MOBILE: 'when you pay with your JCPenney Credit Card',
    BANNER_TEXT_EMPTY_CART: 'Save on your order today when you open a new JCPenney Credit Card',
    CONDITIONS_TEXT: 'Subject to credit approval. Exclusions apply.',
    BUTTON_TEXT: 'Get Details',
    SUBTOTAL: 'Subtotal',
    EST_SAVINGS: 'Estimated Savings',
    AFTER_SAVINGS: 'After Savings',
    BANNER_15_OFF: '15% Off',
    BANNER_5_OFF: '5% Off',
    EMPTY_CART_MESSAGE_15: 'Select apparel, shoes, accessories, fine jewelry, home & salon',
    EMPTY_CART_MESSAGE_5: 'Select major appliances and modern bride® diamond vault',
    BANNER_CODES: ['PROMOFINANCE', 'APPLYANDBUY', 'EMPTYCART', 'SAVEDCARDPROMOFINANCEBANNER'],
    APPLY_AND_BUY_CODE: 'APPLYANDBUY',
    EMPTY_CART_CODE: 'EMPTYCART',
    PROMO_FINANCE_CODE: 'PROMOFINANCE',
    SAVED_CARD_PROMOFINANCE_CODE: 'SAVEDCARDPROMOFINANCEBANNER',
};
export const TOKEN_API_DOWN_MESSAGE =
    'We regret to inform you that due to technical difficulties, we are unable to access your account. In the meantime, please continue to place this order as a guest customer.';
export const DELIVERY_CHANGE_MESSAGE = 'Delivery method for this item has changed.';
export const PLACE_ORDER_GENERIC_ERROR = {
    ERROR_TITLE: 'We apologize, but we cannot place your order at this time',
    ERROR_MESSAGE:
        'If you would like to continue with this order, please call Customer Service at 800-322-1189.',
};
export const MODAL_ERROR_PREFIX = 'Modal: ';
export const SESSION_ERROR = {
    TITLE: 'Session Expired',
    PAYMENT_TITLE: "We can't process this payment",
    ERROR_MESSAGE: 'For your protection, this session expired due to inactivity. Please try again.',
};
export const STREET_ERROR_MESSAGE =
    "The street address entered doesn't appear to have a valid house number. Please double-check the information you entered.";
export const CREATE_ACC_SUCCESS_MSG = 'You’ve successfully created a jcp.com account';
export const CAPTCHA_TYPES = {
    INVISIBLE: 'invisible',
    VISIBLE: 'visible',
};
export const IRIS_MARKETING_SLOT = {
    xlarge: 'desktop',
    large: 'tablet',
    medium: 'tablet',
    small: 'tablet',
};

export const CUSTOM_ERR_MSG = {
    message:
        'Your account has been locked. Check your email for instructions on how to unlock it, or click <a href="/forgotpassword">here</a> to reset your password.',
    errorCode: 'SVC_USR_ERR_RESET_PASSWORD_REQUIRED',
};
export const PROMOFINANCE_ANALYTICS = {
    rewardsApplied: '5% reward applied and Promo Financing Eligible',
    promoAccepted: 'Promo Financing Accepted and 5% reward was applied',
};
export const REWARD_PROMO_FINANCE_CONFLICT = 'REWARD_PROMO_FINANCE_CONFLICT';
export const REWARD_PROMO_FINANCE_ELIGIBLE = 'REWARD_PROMO_FINANCE_ELIGIBLE';
export const REWARD_CATEGORY = 'NEWCUSTOMER';
export const PROMOFINANCE_OPTION_TYPE = 'PROMO_FINANCE';
export const REWARD_OPTION_TYPE = 'NEW_CUSTOMER_REWARD';
export const ORDER_REVIEW_ERROR_SUBCODE = 'ORDER_REVIEW';
export const APPLE_PAY_PAYMENT_RESTRICTED_COUPON_MESSAGE =
    'USE A JCPENNEY CARD TO GET THE BEST DISCOUNT FOR';
export const APPLE_PAY_REQUEST_TEMPLATE = {
    countryCode: 'US',
    currencyCode: 'USD',
    supportedNetworks: ['visa', 'mastercard', 'discover', 'amex'],
    requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    merchantCapabilities: ['supports3DS'],
    total: {
        label: 'TOTAL',
        amount: 1,
        type: 'pending',
    },
};

const APPLEPAY_ERROR_CONTACT_FIELD = {
    name: {
        contactField: 'name',
        messageOverride: false,
        customErrMsg: '',
    },
    postalAddress: {
        contactField: 'postalAddress',
        messageOverride: false,
        customErrMsg: '',
    },
    addressLines: {
        contactField: 'addressLines',
        messageOverride: false,
        customErrMsg: '',
    },
    locality: {
        contactField: 'locality',
        messageOverride: false,
        customErrMsg: '',
    },
    administrativeArea: {
        contactField: 'administrativeArea',
        messageOverride: false,
        customErrMsg: '',
    },
    country: {
        contactField: 'country',
        messageOverride: false,
        customErrMsg: '',
    },
    postalCode: {
        contactField: 'postalCode',
        messageOverride: false,
        customErrMsg: '',
    },
    phoneNumber: {
        contactField: 'phoneNumber',
        messageOverride: false,
        customErrMsg: '',
    },
};
export const APPLEPAY_ERROR_MAP = {
    DELIVERY_STH: {
        code: 'shippingContactInvalid',
        SRV_CUSTOMER_PHONE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.phoneNumber,
        SRV_CUSTOMER_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.administrativeArea,
        API_ERR_FIELD_STATE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.administrativeArea,
        SRV_CUSTOMER_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalCode,
        API_ERR_FIELD_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalCode,
        SRV_CUSTOMER_STD_CDI002_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.addressLines,
        SRV_CUSTOMER_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.name,
        SRV_CUSTOMER_FIRSTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.name,
    },
    BILLING_APPLEPAY: {
        code: 'billingContactInvalid',
        SRV_CUSTOMER_FIRSTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_FIRSTNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_FIRSTNAME_MAX_VOILATED: APPLEPAY_ERROR_CONTACT_FIELD.name,
        SRV_CUSTOMER_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_LASTNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_LASTNAME_MAX_VOILATED: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_LASTNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.name,
        API_ERR_FIELD_COMPANYNAME_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.postalAddress,
        API_ERR_FIELD_COMPANYNAME_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalAddress,
        API_ERR_FIELD_LINETWO_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalAddress,
        API_ERR_FIELD_LINEONE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.addressLines,
        API_ERR_FIELD_LINEONE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.addressLines,
        SRV_CUSTOMER_STD_CDI002_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.addressLines,
        API_ERR_FIELD_CITY_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.locality,
        API_ERR_FIELD_CITY_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.locality,
        API_ERR_FIELD_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.administrativeArea,
        API_ERR_FIELD_STATE_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.administrativeArea,
        SRV_CUSTOMER_STATE_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.administrativeArea,
        API_ERR_FIELD_COUNTRY_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.country,
        API_ERR_FIELD_COUNTRY_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.country,
        API_ERR_FIELD_ZIP_MISSING: APPLEPAY_ERROR_CONTACT_FIELD.postalCode,
        API_ERR_FIELD_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalCode,
        SRV_CUSTOMER_ZIP_INVALID: APPLEPAY_ERROR_CONTACT_FIELD.postalCode,
    },
};
export const EXPRESS_CHECKOUT = {
    expressCheckoutLabel: 'NEW! Checkout Faster Next Time',
    expressCheckoutDescription: 'Default to these shipping & payment options on your next order',
};
export const allowedQueryParams = ['pTmplType'];
export const zipCodeChange = {
    CHANGE_ZIP_CODE: 'Change Zip Code',
    APPLY_ZIP_CODE: 'Apply',
    CANCEL_ZIP_CODE: 'Cancel',
    EMPTY_ZIPCODE: 'Enter a Zip code',
    INVALID_ZIPCODE: 'Enter a Valid Zip code',
    CHANGE_ZIPLINK: 'Change Zip',
    GENERIC_ERROR_MSG: 'Please try again',
};
export const giftCardBannerMsg = {
    itemAdded: 'Item added and you reached FREE shipping!',
    partialItemAdded: 'Item added',
    error: 'Please try again',
};
export const keepMeSignedInText = {
    label: 'Keep Me Signed In',
    description: 'Select this option to stay signed in longer',
    tooltipMsg:
        'We recommend only selecting this option on your personal devices. You can always turn this feature off by signing out on this device.',
};
export const crossSell = {
    title: 'Recommended Accessories:',
};
export const LOADER_BUTTON = {
    PAYPAL: 'PayPal',
};
export const JCP = 'JCP';
export const JCPENNEY_MASTERCARD = 'JCPENNEY MASTERCARD';
export const PLCC = 'PLCC';
export const DC = 'DC';
export const GIFT_CARD = 'GIFTCARD';
export const SRV_BOPIS_STORE_DISTANT_FROM_ZIP = 'SRV_BOPIS_STORE_DISTANT_FROM_ZIP';
export const SRV_STS_STORE_DISTANT_FROM_ZIP = 'SRV_STS_STORE_DISTANT_FROM_ZIP';
